import { useEffect } from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import { SITE_URL } from "../../config/site";
import { useCart } from "../../cart/CartContext";
import "./SuccessPage.css";

export default function SuccessPage() {
  const { clearCart } = useCart();

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  return (
    <>
      <SEO
        title="Pedido recibido | Imalandia"
        description="Confirmación de pedido recibido correctamente en Imalandia."
        canonical={`${SITE_URL}/success`}
        noindex
      />

      <Header />

      <main className="checkout-result-page">
        <section className="checkout-result-card success">
          <span className="checkout-result-icon">✓</span>

          <h1>Pedido recibido correctamente</h1>

          <p>
            Hemos recibido tu pago y tus archivos. Prepararemos tu pedido lo
            antes posible.
          </p>

          <p className="checkout-result-note">
            Recibirás la información del pedido en tu email.
          </p>

          <Link to="/" className="checkout-result-link">
            Volver al inicio
          </Link>
        </section>
      </main>

      <Footer />
    </>
  );
}
